import { useState, useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import { ThemeProvider, CssBaseline } from '@mui/material'
import CompanyAdmin from './components/CompanyAdmin'
import { lightTheme, darkTheme } from './theme'
import './App.css'

// Read initial dark mode state from localStorage
const getInitialDarkMode = () => {
  const userData = localStorage.getItem('cme_user')
  if (userData) {
    try {
      const user = JSON.parse(userData)
      const isDark = user.theme === 'dark'
      // Apply dark class immediately to prevent flash
      if (isDark) {
        document.documentElement.classList.add('dark')
      } else {
        document.documentElement.classList.remove('dark')
      }
      return isDark
    } catch (e) {
      // ignore parse errors
    }
  }
  return false
}

function CompanyAdminApp() {
  const [isDarkMode, setIsDarkMode] = useState(getInitialDarkMode)

  // Listen for theme changes
  useEffect(() => {
    const handleThemeChange = () => {
      const userData = localStorage.getItem('cme_user')
      if (userData) {
        try {
          const user = JSON.parse(userData)
          const isDark = user.theme === 'dark'
          setIsDarkMode(isDark)
          if (isDark) {
            document.documentElement.classList.add('dark')
          } else {
            document.documentElement.classList.remove('dark')
          }
        } catch (e) {
          // ignore parse errors
        }
      }
    }

    window.addEventListener('themeChanged', handleThemeChange)
    return () => window.removeEventListener('themeChanged', handleThemeChange)
  }, [])

  return (
    <ThemeProvider theme={isDarkMode ? darkTheme : lightTheme}>
      <CssBaseline />
      <CompanyAdmin isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />
    </ThemeProvider>
  )
}

ReactDOM.createRoot(document.getElementById('root')).render(<CompanyAdminApp />)
